import logodanai from "../../../assets/img/logo-adiwisista.png"
import bantuan from "../../../assets/img/homepage/bantuan.png"
import youtube from "../../../assets/img/footer/youtube.svg"
import facebook from "../../../assets/img/footer/ic-social-facebook.svg"
import instagram from "../../../assets/img/footer/ic-social-instagram.svg"
import linkedin from "../../../assets/img/footer/ic-social-linkedin.svg"
import email from "../../../assets/img/footer/ic-social-mail.svg"
import megaphone from "../../../assets/img/footer/Megaphone.png"

function Footer() {
    return (
        <footer className="footer">
            <div className="general-container">
                <div className="link-box">
                    <div className="ui-g-12">
                        <img className="footer-img"
                            src={logodanai}
                            alt="Danai.id by Adiwisista" />
                    </div>
                    <div className="ui-g-12">
                        <div className="ui-g-3 sitemap-box">
                            <strong className="footer-link" style={{ fontSize: '20px' }}>Layanan</strong>

                            <br /><br />
                            <a className="footer-link" href="pinjaman-individu">Pinjaman</a>
                            <br /><br />
                            <a className="footer-link" href="pendanaan">Pendanaan</a>
                            <br /><br />
                            <a className="footer-link" href="perusahaan-mitra">Perusahaan Mitra</a>
                        </div>
                        <div className="ui-g-4 faq-link">
                            <strong className="footer-link" style={{ fontSize: '20px' }}>Tentang Danai.id</strong>

                            <br /><br />
                            <a className="footer-link" href="tentang-kami">Tentang Kami</a>
                            <br /><br />
                            <a className="footer-link" href="/#informasi-statistik">Informasi Statistik</a>
                            <br /><br />
                            <a className="footer-link" href="media-informasi">Media Informasi</a>
                        </div>
                        <div className="ui-g-5 help-box">
                            <strong className="footer-link" style={{fontSize: '20px'}}>Pusat Bantuan</strong>

                            <br/><br/>
                            <a className="footer-link" href="faq">FAQ</a>
                            <br/><br/>
                            <a className="footer-link" href="hubungi-kami">Hubungi Kami</a>
                            <br/><br/>
                            <a className="footer-link" href="tnc">Syarat dan Ketentuan</a>
                            <br/><br/>
                            <a className="footer-link" href="pernyataan-privasi">Pernyataan Privasi</a>
                        </div>
                        <div className="ui-g-12">
                            <p>© 2018 - <span className="current-year">2025</span>
                                <strong> PT Adiwisista Finansial Teknologi</strong>. All rights reserved.</p>
                        </div>
                    </div>
                </div>
                <div className="link-box cs-box">
                    <div className="ui-g-12">
                        <div className="ui-g-9 customer-box">
                            <img src={bantuan} style={{ width: '64px', height: '64px', position: 'absolute' }}
                                alt="Danai.id by Adiwisista" />
                        </div>
                        <div className="ui-g-3 customer-box alt">
                            <div className="ui-g-12 footer-customer-care alt">Perlu Bantuan?</div>
                            <div className="ui-g-12 footer-customer-care">021 - 5010 3363</div>
                            <div className="ui-g-12 footer-customer-care">customer.care@danai.id</div>
                        </div>
                    </div>
                    <div className="ui-g-12">
                        <nav>
                            <ul>
                                <li><a href="https://www.youtube.com/channel/UCEq95TmkrBeELAvksHFejVg" target="_blank"
                                    className="ui-link ui-widget linkedin" rel="noopener noreferrer">
                                    <img src={youtube} alt="youtube" /></a>
                                </li>
                                <li><a href="https://www.facebook.com/danai.indonesia" target="_blank"
                                    className="ui-link ui-widget facebook" rel="noopener noreferrer">
                                    <img src={facebook} alt="facebook" /></a>
                                </li>
                                <li><a href="https://www.instagram.com/danai.id/" target="_blank"
                                    className="ui-link ui-widget instagram" rel="noopener noreferrer">
                                    <img src={instagram} alt="instagram" /></a>
                                </li>
                                <li><a href="https://www.linkedin.com/company/danai-indonesia/" target="_blank"
                                    className="ui-link ui-widget linkedin" rel="noopener noreferrer">
                                    <img src={linkedin} alt="linkedin" /></a>
                                </li>
                                <li><a href="mailto:customer.care@danai.id" className="ui-link ui-widget mail">
                                    <img src={email} alt="email" /></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="footer-untuk-diketahui">
                <div className="warning-section">
                    <p>
                        HATI-HATI, TRANSAKSI INI BERISIKO TINGGI. ANDA DAPAT SAJA MENGALAMI KERUGIAN ATAU KEHILANGAN UANG. JANGAN BERUTANG JIKA TIDAK MEMILIKI KEMAMPUAN MEMBAYAR. PERTIMBANGKAN SECARA BIJAK SEBELUM BERTRANSAKSI.
                    </p>
                    <img src={megaphone} alt="megaphone"/>
                </div>
                <div className="ui-g-12 title">
                    <h4> Untuk Diketahui </h4>
                </div>
                <div className="ui-g-12 body">
                    <article>
                        <ol>
                            <li>
                                PT Adiwisista Finansial Teknologi (Danai.id) telah memiliki izin usaha dari Otoritas Jasa Keuangan (OJK) sesuai dengan surat keputusan nomor KEP-76/D.05/2021 tanggal 19 Agustus 2021 tentang Pemberian Izin Usaha Perusahaan Penyelenggara Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi. Pelaksanaan kegiatannya diawasi secara ketat berdasarkan Peraturan OJK Nomor 40 Tahun 2024 mengenai Layanan Pendanaan Bersama Berbasis Teknologi Informasi.
                            </li>
                            <li>
                                Layanan Pendanaan Bersama Berbasis Teknologi Informasi (LPBBTI) merupakan wujud kesepakatan dan hubungan perdata antara Pemberi Pinjaman dengan Penerima Pinjaman, sehingga segala risiko dan akibat hukum daripadanya ditanggung sepenuhnya oleh masing-masing pihak.
                            </li>
                            <li>
                                Seluruh kerugian dari dan atau terkait dengan kesepakatan pinjam meminjam sepenuhnya ditanggung oleh Pemberi Pinjaman, Karena tidak ada lembaga atau otoritas negara yang bertanggung jawab atas risiko dan kerugian tersebut.
                            </li>
                            <li>
                                Sebelum melakukan kegiatan pendanaan dan pinjam meminjam, disarankan untuk terlebih dahulu mempelajari informasi mengenai penggunaan layanan ini, atau dapat berkonsultasi dengan konsultan keuangan Anda.
                            </li>
                            <li>
                                Sebelum melakukan kegiatan pendanaan, Pemberi Pinjaman disarankan untuk terlebih dahulu mempertimbangkan tingkat bunga pinjaman dan biaya-biaya lainnya.
                            </li>
                            <li>
                                Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui masyarakat luas di media sosial serta dapat menjadi alat bukti hukum yang sah menurut peraturan mengenai informasi dan transaksi elektronik dalam proses penyelesaian sengketa dan penegakan hukum.
                            </li>
                            <li>
                                Pengguna (baik Pemberi Pinjaman maupun Penerima Pinjaman) wajib membaca dan memahami informasi ini sebelum memutuskan untuk bergabung sebagai Pengguna.
                            </li>
                            <li>
                                Keputusan Pengguna untuk memanfaatkan pinjaman fintek merupakan bukti pemahaman atas Pengguna untuk Informasi ini.
                            </li>
                            <li>
                                Pemerintah (dalam hal ini Otoritas Jasa Keuangan) tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan Pengguna ( baik Pemberi Pinjaman maupun Penerima Pinjaman) dikarenakan kesengajaan atau kelalaian terhadap ketentuan peraturan perundang-undangan maupun kesepakatan antara Penyelenggara dengan Pengguna.
                            </li>
                            <li>
                                Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan kesepakatan mengenai
                                pinjam meminjam antara atau yang melibatkan Penyelenggara dengan Pengguna wajib
                                dilakukan melalui
                                <i> escrow account</i> dan
                                <i> virtual account</i> sebagaimana yang diwajibkan berdasarkan Peraturan Otoritas Jasa
                                Keuangan Nomor 40 Tahun 2024 tentang Layanan Pendanaan Bersama Berbasis Teknologi
                                Informasi, dan pelanggaran atau ketidakpatuhan terhadap ketentuan tersebut merupakan
                                bukti telah terjadinya pelanggaran hukum oleh Penyelenggara sehingga Penyelenggara wajib
                                menanggung ganti rugi yang diderita oleh masing-masing Pengguna sebagai akibat langsung
                                dari pelanggaran hukum tersebut diatas tanpa mengurangi hak Pengguna yang menderita
                                kerugian menurut Kitab Undang-Undang Hukum Perdata.
                            </li>
                        </ol>
                    </article>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
